import React from 'react';
import { H4, P, Button, Flex, Modal, IconButton } from 'design-system-web';
import cs from 'classnames';

import styles from './DraftChargeConfirmationModal.scss';
import { FONT_AWESOME_REGULAR } from 'lane-shared/helpers/constants/icons';
import { DraftChargeInvoiceOptions } from '../DraftChargeInvoiceOptions/DraftChargeInvoiceOptions';
import { InvoiceType } from 'graphql-query-contracts';

export function DraftChargeConfirmationModal({
  isOpen,
  onClose,
  handleConfirm,
  title,
  description,
  cancelText,
  confirmText,
  testId,
  children,
  confirmActionDisabled = false,
  cancelActionDisabled = false,
  loading = false,
  isFullWidth = false,
  updateChargeDetails,
  isInvoiceOptionEnabled,
  invoiceType,
}: {
  isOpen: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  title: string;
  description?: string;
  cancelText: string;
  confirmText: string;
  testId?: string;
  children?: React.ReactNode;
  confirmActionDisabled?: boolean;
  cancelActionDisabled?: boolean;
  loading?: boolean;
  isFullWidth?: boolean;
  updateChargeDetails: (value: InvoiceType | Date, fieldname: string) => void;
  isInvoiceOptionEnabled: boolean;
  invoiceType?: InvoiceType;
}) {
  const [isInvoiceOptionsValid, setIsInvoiceOptionsValid] =
    React.useState(true);

  const hasDescription = Boolean(description);

  const isSubmitDisabled = confirmActionDisabled || !isInvoiceOptionsValid;

  return (
    <Modal
      className={
        isFullWidth ? cs(styles.modal, styles.fullWidth) : styles.modal
      }
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      testId={testId}
      includeHeader={false}
      isCloseButtonHidden
      disableContentPadding
      disableCloseOnBackgroundClick={loading}
    >
      <Flex
        className={styles.modalHeader}
        justify="space-between"
        align="center"
      >
        <H4>{title}</H4>
        <IconButton
          type={FONT_AWESOME_REGULAR}
          onClick={onClose}
          icon="times"
          data-test="closeButton"
          size="medium"
          disabled={loading}
        />
      </Flex>

      <Flex className={styles.modalBody} direction="column" gap={4}>
        {hasDescription && <P className={styles.Description}>{description}</P>}
        {children}
      </Flex>

      {isInvoiceOptionEnabled && (
        <DraftChargeInvoiceOptions
          updateChargeDetails={updateChargeDetails}
          invoiceType={invoiceType}
          onValidationChange={setIsInvoiceOptionsValid}
        />
      )}

      <Flex className={styles.modalActions} gap={3}>
        <Button
          variant="primary"
          size="large"
          onClick={handleConfirm}
          disabled={isSubmitDisabled}
          loading={loading}
          testId="submit-charge-confirmation-button"
        >
          {confirmText}
        </Button>
        <Button
          variant="secondary"
          size="large"
          onClick={onClose}
          disabled={cancelActionDisabled}
          testId="cancel-charge-confirmation-button"
        >
          {cancelText}
        </Button>
      </Flex>
    </Modal>
  );
}
